// src/components/FTSearchModal.jsx
import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import _ from 'lodash';
import {useSelector} from "react-redux";
import SwapBox from '../components/FilterComponents/SwapBox';
import DropDownBox from '../Fields/DropDownBox';
import { FaPlus, FaMinus } from "react-icons/fa";
import GQPopup from '../components/GQPopups/GQPopup';
import { ca } from 'date-fns/locale';


const useStyles = makeStyles(() => ({
  modalClassConDSI: { borderRadius: "8px", width: "900px" },
  topBar: {
    padding: '12px 20px 0px 17px',
    borderBottom: 'none',
  },
  bodyPad: { padding: '15px'},
  footerBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '10px 16px'
  },
  btn: {
    padding: '8px 14px',
    borderRadius: '4px',
    cursor: 'pointer',
    border: 'none',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      color: 'rgb(0 0 0 / 26%)'
    }
  },
  btnGrey: { background: '#e0e0e0', color: '#222' },
  btnBlue: { background: '#1976d2', color: '#fff' },
  btnOrange: { background: '#db862c', color: '#fff' }
}));

const sortOptions = [
    { value: 'ASC', label: 'Default' },
    { value: 'DES', label: 'Reversed' },
    { value: 'CUSTOM', label: 'Custom SortOrder' },
];


const widgetAtom ={
    filterName:"",
    type: "custom",
    idx: -1,
    Criteria: [{
        field:"",
        SortOrder: _.cloneDeep(sortOptions[0]),
        CustomOrder:[]
    }]

}

const criterionAtom = {
    field:"",
    SortOrder: _.cloneDeep(sortOptions[0]),
    CustomOrder:[]
}

const PfmFilterModal = ({ start, apply, cancel, isOpen}) => {
 
  const classes = useStyles();
  const toggle = useSelector(state => state?.setToggle?.toggle);

  const [widgetState, setWidgetState] = useState(_.cloneDeep(widgetAtom));

  const criteria = Array.isArray(widgetState?.Criteria) ? widgetState.Criteria : [];

  useEffect(() => {
      if (start && typeof start === 'object' && Object.keys(start).length > 0) {
      setWidgetState({
        ...start,
        Criteria: Array.isArray(start.Criteria) ? start.Criteria : _.cloneDeep(widgetAtom.Criteria)
      });
      } else{
      setWidgetState(_.cloneDeep(widgetAtom));
      }
      
    
  }, [start]);

  const save =  async (state) => {
    //do callback
    toast.info('Saving Preferred Family Member Filter...');
  }

  const handleAddCriterion = (index) => {
    setWidgetState((prev) => {
      const nextCriteria = Array.isArray(prev?.Criteria) ? [...prev.Criteria] : [];
      const insertAt = typeof index === 'number' ? index + 1 : nextCriteria.length;
      nextCriteria.splice(insertAt, 0, _.cloneDeep(criterionAtom));
      return { ...prev, Criteria: nextCriteria };
    });
  };

  const handleRemoveCriterion = (index) => {
    setWidgetState((prev) => {
      const nextCriteria = Array.isArray(prev?.Criteria) ? [...prev.Criteria] : [];
      if (nextCriteria.length <= 1) {
        return prev;
      }
      nextCriteria.splice(index, 1);
      return { ...prev, Criteria: nextCriteria };
    });
  };

  const handleClear = () => {
    setWidgetState(_.cloneDeep(widgetAtom));
  };

  return (
   <GQPopup
      show={isOpen}
      close={()=>{cancel()}}
      innerHtml={
        <div>
          <div style={{padding: '15px'}}>
            <h3 style={{width: "600px", padding: "15px", paddingLeft: "0px"}}>
                Define your Preferred Family Member Filter
            </h3>
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <span style={{fontSize: "13pt"}}>Within each family we will sort the patents based on criteria and keep the one from the top of the list</span>
                <input type="text" value={widgetState.filterName || ''} onChange={(e) => setWidgetState(prev => ({...prev, filterName: e.target.value}))} placeholder="Filter Name" style={{marginLeft: '10px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc'}} />
            </div>
          </div>
        <hr style={{marginTop: '10px', borderColor: '#444'}} />
        {criteria.map((criterion, index) => (
        <div key={`criterion-${index}`}>
        <div style={{display: "flex", width: "100%", gap: "20px", padding: "25px 15px 0 15px"}}>
            {index == 0? <span style={{ fontSize: "13pt", fontWeight: "600"}}>sort by</span> : <span style={{ fontSize: "13pt", fontWeight: "600"}}>then sort by</span>}
            <DropDownBox 
              margin="normal"
              variant="outlined"
            />
            <div>
            <DropDownBox 
              margin="normal"
              variant="outlined"
            />
            </div>
            <div style={{display:"flex"}}>
              <div 
                  className="plus-min-button" // control-spacer custom-filter-label"
                  onClick={()=>{handleRemoveCriterion(index)}}
                  style={{ display: widgetState.Criteria.length > 1 ? 'flex' : 'none', width: "32px", height: "32px", margin: "2px", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? '#777' : 'white', opacity: criteria.length <= 1 ? 0.5 : 1, cursor: criteria.length <= 1 ? 'not-allowed' : 'pointer'}}
              >
                  <FaMinus/>
              </div>
              <div 
                  className="plus-min-button" // control-spacer custom-filter-label"
                  onClick={()=>{handleAddCriterion(index)}}
                  style={{ width: "32px", height: "32px", margin: "2px", backgroundColor: toggle ? 'white' : '#292929', color: toggle ? '#777' : 'white'}}
              >
                  <FaPlus/>
              </div>
          </div>
        </div>
        <div>
        <SwapBox
            input = {["Family Size", "Most Recent Filing Date", "Earliest Filing Date", "Most Recent Publication Date", "Earliest Publication Date"]}
            startR={criterion.CustomOrder? criterion.CustomOrder : []}
            apply = {(state) => setWidgetState(prev => ({...prev, Criteria: state}))}
        />
        </div>
        </div>
        ))
       }
        
        <div className={classes.footerBar} style={{width: "100%", display: "flex", marginTop: "10px", marginBottom: "-10px"}}>
          <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'flex-start', height: '50px' }}>
              <button className={`${classes.btn} ${classes.btnGrey}`} onClick={()=>handleClear()}>
                  Reset
              </button>
          </div>
          <div style={{display: "flex",  width: "330px", height: '50px', justifyContent: "space-between", alignItems: "center"}}>
            <button className={`${classes.btn} ${classes.btnGrey}`} onClick={()=>{cancel()}}>
              Cancel
            </button>
            <button className={`${classes.btn} ${classes.btnBlue}`} onClick={()=>{save(widgetState)}}>
              Save
            </button>
            <button className={`${classes.btn} ${classes.btnOrange}`} onClick={()=>{apply(widgetState)}}>
              Apply
            </button>
          </div>
        </div>
    </div>
    }/>
  );
};

export default PfmFilterModal;

